<button
  class="tab-buttons-group-item"
  [class.tab-buttons-group-item--active]="isActive"
  type="button"
>
  {{ text }}
</button>
